import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TopicShowcase() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
      {topics.map((t, i) => (
        <Link
          key={t.id}
          to={`/topic/${t.id}`}
          className="group relative overflow-hidden rounded-lg h-[180px] md:h-[200px] cursor-pointer animate-fadeUp"
          style={{ animationDelay: `${i * 70}ms` }}
        >
          <img
            src={t.cover}
            alt={`${t.title} 专题封面`}
            title={`${t.title} - 专题合集在线观看`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20" />
          <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
            <span className="inline-flex w-fit items-center gap-1 px-2.5 py-1 rounded-md bg-secondary-500 text-background-50 text-xs font-medium mb-2">
              <i className="ri-bookmark-3-line" />
              专题合集
            </span>
            <h3 className="text-lg md:text-xl font-bold text-background-50">{t.title}</h3>
            <p className="mt-1 text-xs md:text-sm text-background-200 line-clamp-2 max-w-md">{t.intro}</p>
            <span className="mt-2 inline-flex items-center gap-1 text-xs md:text-sm text-secondary-300 font-medium">
              共 {t.videoIds.length} 部内容
              <i className="ri-arrow-right-s-line" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}